export function SendMailInfoStep(props) {
  const { stepNum, iconUrl="", alt, title, children, stepImage=null, stepClass="" } = props;
  const useStepImage = !!stepImage;
  const stepImageClass = useStepImage ? "send-mail__step-image" : "";

  return (
    <li className={`send-mail__step send-mail__${stepClass} ${stepImageClass}`}>
      <span className="send-mail__icon">{useStepImage ? stepImage : stepNum}</span>
      <h4 className="delta">{title}</h4>
      <div className="send-mail__step-content">
        {children}
      </div>
      {iconUrl ? <img src={iconUrl} alt={alt} /> : null}
    </li>
  )
}

export default SendMailInfoStep;